import React, { useState } from 'react';
import Button from '../../components/Button/Button';
import { updateContentUpload } from '../../services/handleImage';
import { notification } from 'antd';

const UpdateText = ({
  id,
  selectedContent,
  schoolId,
  courseId,
  topicId,
  lessonId,
  handleCancel,
  close,
}) => {
  const [textTitle, setTextitle] = useState(selectedContent?.title);
  const [description, setDescription] = useState(selectedContent.description);
  const [loading, setLoading] = useState(false);

  const update = async () => {
    try {
      setLoading(true);

      let res = await updateContentUpload(
        selectedContent?.sn,
        textTitle,
        90,
        'text',
        false,
        '',
        '',
        schoolId,
        courseId,
        topicId,
        lessonId,
        description,
        (event) => {},
        selectedContent.id
      );
      setLoading(false);

      notification['success']({
        message: res.message,
      });
      close();
    } catch (error) {
      notification['error']({
        message: error?.response?.data?.data?.errors?.file[0],
      });
      setLoading(false);
    }
  };

  return (
    <div className='add-course__content-wrap'>
      <label
        className='add-course__content-selection__head'
        style={{ marginBottom: '16px' }}
      >
        <div
          className='add-course__content-selection__head__title'
          style={{ display: 'flex', gap: '16px' }}
        >
          {' '}
          <p> Update Text Title</p>
        </div>
      </label>

      <div
        className='auth-wrapper__right__form__inputwrapper eye-position'
        style={{ width: '100%' }}
      >
        <input
          type='text'
          name='textTitle'
          id='textTitle'
          value={textTitle}
          onChange={(e) => setTextitle(e.target.value)}
          placeholder=''
        />
        <div className='eye-icon'></div>
        <p style={{ fontSize: '12px', marginLeft: 'auto' }}>
          max of 80 characters
        </p>
      </div>
      <div
        className='auth-wrapper__right__form__inputwrapper'
        style={{ width: '100%', marginTop: '40px' }}
      >
        <label htmlFor='bio'>Text Content</label>

        <textarea
          id='description'
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          maxlength='200'
          name='description'
          placeholder=''
        />
      </div>

      <div className='edit-modal__bottom'>
        <p onClick={() => close()}>Cancel</p>
        <Button text='Save' className='primary-btn' onClick={() => update()} />
      </div>
    </div>
  );
};

export default UpdateText;
